@if (data) {
  <div class="dialog-container">
    <form (submit)="onSubmit()">
      <div class="field">
        <span> {{ "DIALOG.SESSION_CHANGE_PASSWORD.LABEL_PASSWORD" | translate }} </span>
        <app-template-password [control]="passwordControl" />
      </div>
      <div class="field">
        <span>{{ "DIALOG.SESSION_CHANGE_PASSWORD.LABEL_PASSWORD_REPEAT" | translate }}</span>
        <app-template-password [control]="passwordConfirmControl" />
      </div>
      <div>
        <button mat-stroked-button type="submit">{{ "DIALOG.SESSION_CHANGE_PASSWORD.SUBMIT" | translate }}</button>
      </div>
    </form>
  </div>
}
